import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Typography, FormHelperText } from '@material-ui/core';
import { ErrorMessage } from 'formik';

const CustomRichText = ({ field, label, form, form: { touched, errors } }) => {
  const editorState =
    form.values[`${field.name}_state`] || EditorState.createEmpty();

  React.useEffect(() => {
    if (field.value && !form.values[`${field.name}_state`]) {
      const markdownString = field.value;
      const rawData = markdownToDraft(markdownString);
      const contentState = convertFromRaw(rawData);
      const newEditorState = EditorState.createWithContent(contentState);
      form.setFieldValue(`${field.name}_state`, newEditorState);
    }
  }, [field.value]);

  const onChange = newEditorState => {
    form.setFieldValue(`${field.name}_state`, newEditorState);
    const content = newEditorState.getCurrentContent();
    const rawObject = convertToRaw(content);
    const markdownString = draftToMarkdown(rawObject);
    form.setFieldValue(field.name, markdownString);
  };
  return (
    <>
      <Typography
        variant="h6"
        style={{
          color: '#282829',
          marginTop: 10,
          marginBottom: 14,
          marginLeft: -1,
        }}
      >
        {label}
      </Typography>
      <Editor
        editorState={editorState}
        onEditorStateChange={onChange}
        toolbar={{
          link: { inDropdown: true },
          options: ['inline', 'blockType', 'link', 'list', 'history'],
          inline: {
            options: ['bold', 'italic', 'monospace'],
          },
          blockType: {
            options: [
              'Normal',
              'H1',
              'H2',
              'H3',
              'H4',
              'H5',
              'H6',
              'Blockquote',
            ],
          },
        }}
        localization={{
          locale: 'pt',
        }}
      />
      <ErrorMessage name={field.name}>
        {msg => <FormHelperText error>{msg}</FormHelperText>}
      </ErrorMessage>
    </>
  );
};

CustomRichText.propTypes = {
  field: PropTypes.oneOfType([PropTypes.object]).isRequired,
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  label: PropTypes.string.isRequired,
};

export default CustomRichText;
